import type { NodeProps, StructuredContentDocument } from '../types';
import { NerdyTip } from './nerdy-tip';

export function NerdTip(props: NodeProps<{ children: StructuredContentDocument[] }>) {
  return <NerdyTip {...props} />;
}
